export default __webpack_public_path__ + "static/media/icon-left-pointer.59a4f3c6.svg";